import HeadTittle from "../../../../../components/HeadTittle";
import IncomingInvitationStatus from "../../../Visitor/IncomingInvitation/SubComponents/IncomingInvitationStatus";
import CustomSearch from "../../../../../components/SearchSimples/CustomSearch";
import React from "react";
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {MenuItem} from "@mui/material";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 26 de noviembre de 2025
 */


const IncomingContractorsHeader = ({
                                       isOnline,
                                       setIsReload,
                                       item,
                                       search,
                                       setSearch,
                                       handleChange,
                                       activeContractors
                                   }) => {
    const onReset = () => {
        setSearch("");
    };

    const uniqueCompanies = [
        ...new Map(activeContractors.map(c => [c.companyName, c])).values()
    ];

    return (
        <>
            <HeadTittle name={'incoming_contractors'}>
                <IncomingInvitationStatus isOnline={isOnline} setIsReload={setIsReload} item={item}/>
            </HeadTittle>
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-lg-4 col-xl-4 pl-0'>
                    <CustomSelectAndChildren
                        id="slt_ich_contractor"
                        label="lbl_ich_contractor"
                        name='contractorId'
                        trans='select_contractor'
                        value={item.contractorId || ''}
                        onChange={handleChange}
                        showNoSelectionOption={true}
                    >
                        {uniqueCompanies?.map(e => (
                            <MenuItem key={e.contractorId} value={e.contractorId}>
                                {e.companyName}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
                <div className='col-sm-12 col-md-6 col-lg-8 col-xl-8 pr-0'>
                    <CustomSearch id={'txt_ich_search'}
                                  label={"search_by_name"}
                                  value={search}
                                  setValue={setSearch}
                                  onChange={e => setSearch(e.target.value)}
                                  onReset={onReset}
                    />
                </div>
            </div>

        </>
    );
};

export default IncomingContractorsHeader;
